export enum OrderConfirmationRoutes {
  OrderConfirmation = '/order-confirmation',
}
